import React, { useState } from "react";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./faq.css";

// QuestionCard component
function QuestionCard({ question, answer, no, isOpen, onToggle }) {
  return (
    <div className="question-container" onClick={onToggle}>
      <div className="question-header">
        <h2>
          {no}. {question}
        </h2>
        <FontAwesomeIcon icon={isOpen ? faMinus : faPlus} className="icon" />
      </div>
      {isOpen && (
        <div
          className="answer-container"
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      )}
    </div>
  );
}

// Section component now uses props for openQuestion
function Section({ title, subtitle, range, questions, openQuestion, setOpenQuestion }) {
  const handleToggle = (no) => {
    setOpenQuestion((prev) => (prev === no ? null : no));
  };

  return (
    <div className="faq-section">
      <p className="question-section-header">
        {title} <span>{subtitle}</span>
      </p>
      {questions
        .filter((q) => q.no >= range[0] && q.no <= range[1])
        .map((q) => (
          <QuestionCard
            key={q.no}
            {...q}
            isOpen={openQuestion === q.no}
            onToggle={() => handleToggle(q.no)}
          />
        ))}
    </div>
  );
}

// FAQ data with links
const faqData = [
  {
    no: 1,
    question: "Who is Hirdaramani?",
    answer:
      'Hirdaramani is a leading global apparel manufacturer with over 100 years of heritage. We are a family-owned business rooted in innovation, responsibility and excellence across all aspects of manufacturing and design. For more details, visit <a href="https://www.hirdaramani.lk/corporate/" target="_blank" rel="noopener noreferrer">https://www.hirdaramani.lk/corporate/</a>.',
  },
  {
    no: 2,
    question: "What products and services do you offer?",
    answer:
      'We specialise in manufacturing high-quality apparel across categories including active and outerwear, intimates and underwear and performance apparel. For more details, visit  <a href="https://www.hirdaramani.lk/our-capabilities/" target="_blank" rel="noopener noreferrer">https://www.hirdaramani.lk/our-capabilities/</a>.',
  },
  {
    no: 3,
    question: "What are your core capabilities in apparel manufacturing?",
    answer:
      'Our capabilities include end-to-end apparel solutions—from product development, fabric innovation, design collaboration and digital sampling to lean manufacturing, compliance and on-time delivery at scale. For more details, visit  <a href="https://www.hirdaramani.lk/our-capabilities/" target="_blank" rel="noopener noreferrer">https://www.hirdaramani.lk/our-capabilities/</a>.',
  },
  {
    no: 4,
    question: "Where are your manufacturing facilities located?",
    answer:
      'Hirdaramani operates state-of-the-art manufacturing facilities across Sri Lanka, Bangladesh, Ethiopia and Vietnam while our commercial offices are located across the US, UK and Europe. This strategic global footprint enables us to offer supply chain flexibility and regional advantages to our partners. For more details, visit  <a href="https://www.hirdaramani.lk/footprint/" target="_blank" rel="noopener noreferrer">https://www.hirdaramani.lk/footprint/</a>.',
  },
  {
    no: 5,
    question: "Which global brands do you work with?",
    answer:
      'We proudly partner with some of the world’s most recognised fashion and lifestyle brands, delivering value though ethical sourcing, design innovation and speed-to-market manufacturing. While we maintain client confidentiality, our partners include top names in retail, athleisure and high-street fashion. For more details, visit  <a href="https://www.hirdaramani.lk/our-capabilities/" target="_blank" rel="noopener noreferrer">https://www.hirdaramani.lk/our-capabilities/</a>.',
  },
  {
    no: 6,
    question:
      "What makes Hirdaramani different from other apparel manufacturers?",
    answer:
      'Our commitment to people, planet and purpose sets us apart. We lead with sustainability, invest in innovation and uphold the highest standards in ethical manufacturing. For more details, visit <a href="https://www.hirdaramani.lk/corporate/" target="_blank" rel="noopener noreferrer">https://www.hirdaramani.lk/corporate/</a>.',
  },
  {
    no: 7,
    question: "How does Hirdaramani approach sustainability?",
    answer:
      'Sustainability is at the core of everything we do. Through our ‘Future First Sustainability Roadmap’, we focus on four pillars; Conserving the Environment, Empowering Our Associates, Supporting the Community and Trusting in Good Choices – to drive meaningful change across the value chain and across our global operations. For more details, visit <a href="https://sustainability.hirdaramani.com/" target="_blank" rel="noopener noreferrer">https://sustainability.hirdaramani.com/</a>.',
  },
  {
    no: 8,
    question: "What is the Future First Sustainability Roadmap?",
    answer:
      'Future First is our group-wide strategy that focuses on creating long-term value for people, the planet and our business through proactive environmental and social responsibility. For more details, visit  <a href="https://sustainability.hirdaramani.com/" target="_blank" rel="noopener noreferrer">https://sustainability.hirdaramani.com/</a>.',
  },
  {
    no: 9,
    question: "What certifications and standards do you comply with?",
    answer:
      'We comply with leading global standards including LEED, GOTS, GRS, OEKO-TEX®, WRAP, SA8000, Higg Index, ZDHC, Fair Trade and ISO certifications, ensuring transparency, ethical sourcing and operational excellence. We are also a signatory to the UN Global Compact. For more details, visit <a href="https://sustainability.hirdaramani.com/trust/" target="_blank" rel="noopener noreferrer">https://sustainability.hirdaramani.com/trust/</a>.',
  },
  {
    no: 10,
    question:
      "How does Hirdaramani support innovation in apparel manufacturing?",
    answer:
      'We invest in digital product development, automation and advanced data analytics to enhance efficiency, reduce waste and deliver faster, more agile manufacturing solutions for our customers. For more details, visit  <a href="https://www.hirdaramani.lk/our-capabilities/" target="_blank" rel="noopener noreferrer">https://www.hirdaramani.lk/our-capabilities/</a>.',
  },
  {
    no: 11,
    question: "How do you support your employees and communities?",
    answer:
      'We believe in putting people first. From comprehensive well-being programmes to inclusive workplace policies and continuous upskilling, we empower over 55,000 employees across our operations to thrive. Our community programmes span across education, health, disaster relief, environmental conservation projects and women’s empowerment in the communities where we operate. For more details, visit  <a href="https://sustainability.hirdaramani.com/" target="_blank" rel="noopener noreferrer">https://sustainability.hirdaramani.com/</a>.',
  },
  {
    no: 12,
    question:
      "Are you open to new business partnerships or supplier inquiries?",
    answer:
      'We welcome inquiries from potential brand partners, innovators and suppliers who align with our values of excellence, responsibility and mutual growth. Please visit our  <a href="https://www.hirdaramani.lk/contact/" target="_blank" rel="noopener noreferrer">Contact</a> page to get in touch.',
  },
  {
    no: 13,
    question: "How can I apply for a job at Hirdaramani?",
    answer:
      'Visit our <a href="https://www.hirdaramani.com/careers/" target="_blank" rel="noopener noreferrer">Careers</a> section to explore current opportunities and learn more about our people-first culture. We are always looking for talented individuals passionate about making a positive impact. For more details, visit.',
  },
  {
    no: 14,
    question: "Do you offer sustainable or recycled fabric solutions?",
    answer:
      'Yes. We work extensively with sustainable materials including organic cotton, recycled polyester and other circular fabric solutions to help our customers meet their sustainability goals. For more details, visit <a href="https://www.hirdaramani.lk/our-capabilities/" target="_blank" rel="noopener noreferrer">https://www.hirdaramani.lk/our-capabilities/</a>.',
  },
  {
    no: 15,
    question: "Where can I learn more about your sustainability performance?",
    answer:
      'You can access our annual <a href="https://sustainability.hirdaramani.com/static/media/H-Sustainability-Targets-2023.bea813365a4ca62d8a8f.pdf" target="_blank" rel="noopener noreferrer">Sustainability Report</a> under the <a href="https://sustainability.hirdaramani.com/static/media/H-Sustainability-Targets-2023.bea813365a4ca62d8a8f.pdf" target="_blank" rel="noopener noreferrer">Sustainability</a> section of our website, which details our goals, progress, certifications, and future commitments. For more details, visit.',
  },
];

// Main FAQ
export default function FAQ() {
  const [openQuestion, setOpenQuestion] = useState(null); // Shared across all sections

  return (
    <div id="next-section">
      <div className="faq-wrapper">
        <Section
          title="About"
          subtitle="Us"
          range={[1, 6]}
          questions={faqData}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
        />
        <Section
          title="Sustainability &"
          subtitle="Innovation"
          range={[7, 11]}
          questions={faqData}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
        />
        <Section
          title="Careers &"
          subtitle="Partnerships"
          range={[12, 15]}
          questions={faqData}
          openQuestion={openQuestion}
          setOpenQuestion={setOpenQuestion}
        />
      </div>
    </div>
  );
}